/**
 * Toggle button for the grid view
 * Switches between the road and cabin view for all ravens on the grid
 * Rendered in GridPage.js
*/

import React from 'react';
import PropTypes from 'prop-types';
import { CameraType } from '../../../data/media';
import './Toggle.scss'
import { strings } from '../../../localization';

export default class ViewToggle extends React.PureComponent {

    handleClick = () => {
        if (this.props.disabled) return;
        this.props.onClick();
    };

    render() {
        const { render, disabled, camera } = this.props;
        if (!render) return null;

        const isRoad = camera === CameraType.CAMERA_ROAD;
        const isCabin = camera === CameraType.CAMERA_CABIN;

        return (
            <div className='view-toggle-wrapper'>
                <button
                    id={this.props.id}
                    className={`view-toggle ${disabled ? 'disabled' : ''}`}
                    onClick={this.handleClick}
                    disabled={isRoad}
                    title={typeof disabled === 'string' ? disabled : undefined}

                >
                    <span className={`toggle-option ${isRoad ? 'active' : ''}`}>
                        {strings.eva_road_camera}
                    </span>
                </button>
                <button
                    id={this.props.id}
                    className={`view-toggle ${disabled ? 'disabled' : ''}`}
                    onClick={this.handleClick}
                    disabled={isCabin}
                    title={typeof disabled === 'string' ? disabled : undefined}
                >
                    <span className={`toggle-option ${isCabin ? 'active' : ''}`}>
                        {strings.eva_cabin_camera}
                    </span>
                </button>
            </div>
        );
    }
}

ViewToggle.propTypes = {
    id: PropTypes.string,
    render: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    camera: PropTypes.oneOf([
        CameraType.CAMERA_ROAD,
        CameraType.CAMERA_CABIN
    ]).isRequired
};
